import type { UpdateUserPasswordInput } from "@src/__generated__/graphql";
import { minLength, password, required } from "@src/utils/forms/validators";
import { FieldState, FormState } from "formstate";
import { makeObservable } from "mobx";

export class FormChangeUserPassword {
  user_id = new FieldState("").validators(required);
  password = new FieldState("").validators(required, minLength(8), password);

  form = new FormState({
    user_id: this.user_id,
    password: this.password,
  });

  constructor(userId: string) {
    makeObservable(this);
    this.user_id.$ = userId;
  }

  serialize(): UpdateUserPasswordInput {
    return {
      id: this.user_id.$,
      password: this.password.$,
    };
  }
}
